export class UnauthenticatedError extends Error {
  message = 'You are not signed in - maybe your session has expired.';
  status = 401;
}
